//console.log('ENTERED PROVIDER DROPDOWN FUNCTION');

async function createAndInsertProviderDropdown() {
    console.log("Attempting to find LCU drawer footer...");
    const lcuFooter = document.querySelector('.lcu__drawer__footer');
    if (!lcuFooter) {
        console.log("LCU drawer footer (.lcu__drawer__footer) not found. Cannot insert provider dropdown.");
        return null;
    }
    console.log("LCU drawer footer found.");

    // Check if dropdown already exists (e.g., if function runs multiple times)
    if (document.getElementById('lcuProviderDropdown')) {
        console.log("LCU provider dropdown already exists.");
        return document.getElementById('lcuProviderDropdown');
    }

    console.log("Creating provider dropdown elements...");
    const container = document.createElement('div');
    container.id = 'lcu-provider-dropdown-container';
    // Position it before the checkout button group (which has order: 1)
    container.style.order = '0';
    container.style.padding = '10px 20px'; // Add some spacing

    const label = document.createElement('label');
    label.htmlFor = 'lcuProviderDropdown';
    label.innerText = 'Select your Provider:';
    label.style.display = 'block';
    label.style.marginBottom = '5px';

    const select = document.createElement('select');
    select.id = 'lcuProviderDropdown';
    select.className = 'input-full'; // Use a common class if available, or style directly
    select.style.width = '100%';
    select.style.padding = '8px';
    select.style.border = '1px solid #ccc';
    select.style.borderRadius = '4px';

    const defaultOption = document.createElement('option');
    defaultOption.value = "";
    defaultOption.innerText = "Select your Provider";
    defaultOption.disabled = true;
    defaultOption.selected = true;
    select.appendChild(defaultOption);

    container.appendChild(label);
    container.appendChild(select);

    // Find the checkout button container to insert before
    const checkoutContainer = lcuFooter.querySelector('div[style*="order: 1"]');
    if (checkoutContainer) {
        console.log("Inserting dropdown before checkout button container.");
        lcuFooter.insertBefore(container, checkoutContainer);
    } else {
        // Fallback: just append to footer if specific container not found
        console.log("Checkout button container not found, appending dropdown to footer.");
        lcuFooter.appendChild(container);
    }


    return select; // Return the created select element
}


async function loadProvidersIntoDropdown() {
    console.log('Running loadProvidersIntoDropdown...');
    let affiliateId;
    let affiliateCode;
    let providerId;

    // --- Dynamically create and insert the dropdown ---
    const dropdown = await createAndInsertProviderDropdown();

    if (!dropdown) {
        console.log('Provider dropdown element could not be created or found. Exiting.');
        // Try updating attributes in case it exists from another source
        updateCartAttributesWithProvider();
        return;
    }
    console.log(`Operating on dropdown element: #${dropdown.id}`);
    // --- End dynamic creation ---


    try {
        affiliateCode = localStorage.getItem('affiliateCode') || sessionStorage.getItem('affiliateCode');
        providerId = localStorage.getItem('providerId') || sessionStorage.getItem('providerId');
        console.log(`Found affiliateCode: ${affiliateCode}, providerId: ${providerId}`);

        // Extract providerId from URL if present
        const urlParams = new URLSearchParams(window.location.search);
        const codeParam = urlParams.get('code');
        if (codeParam && codeParam.includes('-')) {
            const parts = codeParam.split('-');
            providerId = parts[1] || providerId;
            console.log(`Extracted providerId from URL: ${providerId}`);
        }
    } catch (error) {
        console.error("Error accessing localStorage or sessionStorage:", error);
    }

    // Find the container - Adjust selector if needed based on actual structure
    const container = dropdown.closest('#lcu-provider-dropdown-container');


    const allowedAffiliateCodes = ['DRB', 'VEN', 'ENG', 'BSWD115', 'BSWD116', 'REV','ALEXSAESTHETICS', 'ASA', 'WISH', 'DERMATOLOGYOFCT', 'DERMATOLOGYOFCT2', 'DERMATOLOGYOFCT3', 'DERMATOLOGYOFCT4', 'DERMATOLOGYOFCT5', 'DERMATOLOGYOFCT6', 'DERMATOLOGYOFCT7'];
    console.log(`Checking if ${affiliateCode} is in allowed list...`);
    if (!allowedAffiliateCodes.includes(affiliateCode)) {
        console.log(`Affiliate code ${affiliateCode} not allowed. Hiding container and exiting.`);
        if (container) {
            container.style.display = 'none';
            console.log('Hiding provider dropdown container.');
        }
        return;
    } else {
         // Ensure container is visible if code is allowed
        if (container) {
            container.style.display = ''; // Use empty string to revert to default CSS display
             console.log('Ensuring provider dropdown container is visible.');
        } else {
             console.log('Could not find container to ensure visibility.');
        }
    }


    if (affiliateCode) {
        console.log('Affiliate code found, attempting to fetch affiliate ID...');
        try {
            // Ensure the URL is accessible globally
             if (!window.affiliateNamesJSONURL) {
                console.error("window.affiliateNamesJSONURL is not defined!");
                if (container) container.style.display = 'none'; // Hide if we can't fetch
                return;
            }
            const responseAffiliate = await fetch(window.affiliateNamesJSONURL);
            if (!responseAffiliate.ok) {
                throw new Error(`HTTP error! status: ${responseAffiliate.status}`);
            }
            const affiliatesData = await responseAffiliate.json();

            const matchedAffiliate = affiliatesData.find(affiliate => affiliate.affiliateCode === affiliateCode);
            if (matchedAffiliate) {
                 affiliateId = matchedAffiliate.affiliateId;
                 console.log(`Affiliate ID found: ${affiliateId}`);
            } else {
                console.log(`No matching affiliate ID found for code: ${affiliateCode}`);
                 if (container) container.style.display = 'none'; // Hide if no ID found
                 return; // Exit if no matching affiliate
            }
        } catch (error) {
            console.error("Error fetching affiliate data:", error);
            if (container) container.style.display = 'none'; // Hide on error
            return; // Exit on error
        }
    } else {
        console.warn("No affiliateCode available in storage.");
        if (container) container.style.display = 'none'; // Hide if no code
        return; // Exit if no affiliate code
    }

    // Remove dynamically added options first (excluding the default/placeholder)
    if (dropdown) {
        console.log('Removing existing dynamic provider options...');
        const dynamicOptions = dropdown.querySelectorAll('option:not([disabled])');
        dynamicOptions.forEach(option => {
            // Keep the "None of the Above" option structure if needed, remove others
            if (option.value !== '') { // Assuming 'None' option has value='' and is not disabled initially
                dropdown.removeChild(option);
            }
        });
         // Ensure the default option is present and correct
        let defaultOption = dropdown.querySelector('option[disabled]');
        if (!defaultOption) {
            defaultOption = document.createElement('option');
            defaultOption.value = "";
            defaultOption.innerText = "Select your Provider";
            defaultOption.disabled = true;
            defaultOption.selected = true;
            dropdown.insertBefore(defaultOption, dropdown.firstChild);
            console.log('Re-added default placeholder option.');
        } else {
             defaultOption.innerText = "Select your Provider"; // Reset text just in case
             defaultOption.selected = true; // Ensure it's selected initially
        }
    }

    if (affiliateId) {
        console.log('Affiliate ID found, attempting to fetch providers...');
        try {
            const responseProviders = await fetch(`https://merchant-api.skintypesolutions.com/api/fms-affiliates/providers-by-affiliate-id/${affiliateId}`);
             if (!responseProviders.ok) {
                throw new Error(`HTTP error! status: ${responseProviders.status}`);
            }
            const providersData = await responseProviders.json();

            if (providersData && providersData.length > 0) {
                console.log(`Providers data found (${providersData.length} providers). Populating dropdown.`);

                // Clear previous non-default options again to be safe
                const dynamicOptions = dropdown.querySelectorAll('option:not([disabled])');
                dynamicOptions.forEach(option => dropdown.removeChild(option));

                providersData.forEach(provider => {
                    const option = document.createElement('option');
                    option.value = provider.user_affiliate_id;
                    option.innerText = provider.full_name;
                    // option.className = 'dynamic-option'; // Add class if needed for styling/selection
                    dropdown.appendChild(option);
                });

                // Add "None of the Above" option
                const noneOption = document.createElement('option');
                noneOption.value = ''; // Value is empty string
                noneOption.innerText = 'None of the Above';
                // noneOption.className = 'dynamic-option';
                dropdown.appendChild(noneOption);


                console.log(`Attempting to select provider ID: ${providerId}`);
                let providerSelected = false;
                for (let i = 0; i < dropdown.options.length; i++) {
                     // Ensure comparison handles string/number types if necessary
                    if (dropdown.options[i].value && dropdown.options[i].value == providerId) {
                        dropdown.options[i].selected = true;
                        providerSelected = true;
                        console.log(`Selected provider: ${dropdown.options[i].text}`);
                        break;
                    }
                }
                // If a providerId was expected but not found, or no providerId, ensure placeholder is selected
                 if (!providerSelected && dropdown.options.length > 0 && dropdown.options[0].disabled) {
                     dropdown.options[0].selected = true; // Select placeholder
                     console.log('No matching provider ID found or no provider ID stored, ensuring placeholder is selected.');
                 } else if (!providerSelected) {
                      console.log('No provider ID to select, default placeholder remains selected.');
                 }


                updateCartAttributesWithProvider(); // Update attributes now that dropdown is populated
            } else {
                console.log("No providers data returned for the specified affiliateId.");
                 if (container) {
                     container.style.display = 'none'; // Hide if no providers are found
                     console.log('Hiding container as no providers were found.');
                 }
                return; // Exit if no providers
            }
        } catch (error) {
            console.error("Error fetching or processing providers data:", error);
            if (container) container.style.display = 'none'; // Hide on error
        }
    } else {
        // This case should technically be handled earlier, but as a safeguard:
        console.log("No affiliateId derived. Cannot fetch providers.");
        if (container) {
            container.style.display = 'none';
            console.log('Hiding provider dropdown container as no affiliate ID was found.');
        }
    }

    // --- Event Listener ---
    // Moved attaching the listener to the end, after population attempt
     if (dropdown && typeof handleProviderChange === 'function') { // Check if handleProviderChange is defined
        // Remove listener first to avoid duplicates if function runs multiple times
        dropdown.removeEventListener('change', handleProviderChange);
        dropdown.addEventListener('change', handleProviderChange);
        console.log('Event listener attached/re-attached to dropdown.');
    } else if (!dropdown) {
         console.error("Cannot attach listener: Dropdown element not available.");
    } else {
        console.error("Cannot attach listener: handleProviderChange function not defined.");
    }
} // End loadProvidersIntoDropdown


const handleProviderChange = (event) => {
    console.log('Provider selection changed.');
    const dropdown = event.target; // Get the select element
    let selectedValue = dropdown.value;
    let selectedText = '';

     // Find selected option text (handle placeholder case)
    if (dropdown.selectedIndex >= 0 && !dropdown.options[dropdown.selectedIndex].disabled) {
         selectedText = dropdown.options[dropdown.selectedIndex].text;
          // Handle "None of the Above" text explicitly if needed, though value is already ''
         if (selectedText === 'None of the Above') {
            // selectedValue is already ''
            console.log('Selected "None of the Above"');
         }
    } else {
        selectedValue = ''; // Treat selection of disabled placeholder as empty
        selectedText = '';
        console.log('Selected placeholder or invalid option.');
    }

     console.log(`Selected value: ${selectedValue}, Text: ${selectedText}`);


    try {
        // Store the ID (value)
        localStorage.setItem('providerId', selectedValue);
        sessionStorage.setItem('providerId', selectedValue);
         console.log(`Stored providerId: ${selectedValue}`);
    } catch (error) {
        console.error("Error setting providerId in storage:", error);
    }

    // Update cart attributes with the *Name*
    updateCartAttributesWithProvider(selectedText); // Pass selected name directly

    // --- URL Update Logic ---
    let currentAffiliateCode = localStorage.getItem('affiliateCode') || sessionStorage.getItem('affiliateCode');
    console.log(`Updating URL. Current affiliate code from storage: ${currentAffiliateCode}`);

    if (currentAffiliateCode) {
        const currentUrl = new URL(window.location.href);
        const originalCodeParam = currentUrl.searchParams.get('code');
        let newCodeParam = '';

        if (selectedValue === '') { // If "None" or placeholder is selected
            newCodeParam = `${currentAffiliateCode}`;
             console.log(`Set URL code param to: ${currentAffiliateCode}`);
        } else { // If a specific provider is selected
            newCodeParam = `${currentAffiliateCode}-${selectedValue}`;
            console.log(`Set URL code param to: ${currentAffiliateCode}-${selectedValue}`);
        }

         // Only redirect if the 'code' parameter actually changes
        if (originalCodeParam !== newCodeParam) {
             currentUrl.searchParams.set('code', newCodeParam);
             console.log(`Redirecting to: ${currentUrl.toString()}`);
             // Use a short delay to allow attribute update potentially
             setTimeout(function(){
                 window.location.href = currentUrl.toString();
             }, 500);
        } else {
             console.log('URL code parameter did not change, skipping redirect.');
        }
    } else {
        console.warn("Cannot update URL: affiliateCode not found in storage.");
    }
}; // End handleProviderChange

// Make handleProviderChange globally accessible IF NEEDED by inline onchange, but preferably avoid
// window.handleProviderChange = handleProviderChange;


document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded event fired.');
    // Ensure affiliateNamesJSONURL is set before calling
    if (typeof window.affiliateNamesJSONURL === 'undefined') {
         // Attempt to find it from a script tag if not directly set earlier
         const scriptTag = document.querySelector('script[src*="providerDropdown.js"]');
         if (scriptTag && scriptTag.previousElementSibling && scriptTag.previousElementSibling.tagName === 'SCRIPT' && scriptTag.previousElementSibling.innerText.includes('affiliateNamesJSONURL')) {
             try {
                 eval(scriptTag.previousElementSibling.innerText); // Execute script defining the URL
                 console.log('Dynamically evaluated affiliateNamesJSONURL from preceding script.');
             } catch (e) {
                 console.error('Failed to evaluate script for affiliateNamesJSONURL', e);
             }
         }

         if (typeof window.affiliateNamesJSONURL === 'undefined') {
            console.error("CRITICAL: window.affiliateNamesJSONURL is not set. Cannot load providers.");
            return; // Stop if URL isn't available
         }
    }
    loadProvidersIntoDropdown(); // Load on initial DOM ready
    // updateCartAttributesWithProvider(); // Called inside loadProviders... after population now
});


// Modified to accept optional providerName parameter
function updateCartAttributesWithProvider(providerNameToSet = null) {
     console.log('Running updateCartAttributesWithProvider...');
    try {
        const affiliateCode = localStorage.getItem('affiliateCode') || null;
         // If providerNameToSet is passed (from change event), use it directly.
         // Otherwise, try to get stored providerId and find name from dropdown.
        let finalProviderName = providerNameToSet;

        if (finalProviderName === null) { // Only if not passed directly
            const providerId = localStorage.getItem('providerId') || null;
             console.log(`Updating cart attributes. Affiliate: ${affiliateCode}, Stored Provider ID: ${providerId}`);

            if (affiliateCode && providerId) {
                // Find the dropdown (dynamically created one)
                const dropdown = document.getElementById('lcuProviderDropdown');
                let providerNameFromDropdown = '';

                if (dropdown) {
                    for (let i = 0; i < dropdown.options.length; i++) {
                        if (dropdown.options[i].value == providerId) { // Compare value (ID)
                            providerNameFromDropdown = dropdown.options[i].text;
                            break;
                        }
                    }
                     console.log(`Found provider name from dropdown for stored ID: ${providerNameFromDropdown}`);
                     if (providerNameFromDropdown && providerNameFromDropdown !== 'Select your Provider' && providerNameFromDropdown !== 'None of the Above') {
                          finalProviderName = providerNameFromDropdown;
                     } else if (providerNameFromDropdown === 'None of the Above') {
                         finalProviderName = ''; // Ensure empty string for "None"
                     }
                } else {
                     console.log("Dropdown #lcuProviderDropdown not found to get provider name initially.");
                }
            } else {
                 console.log('Skipping initial cart attribute name lookup (no providerId or affiliateCode found in storage).');
                 finalProviderName = ''; // Default to empty if no stored ID or affiliate
            }
        } else {
            console.log(`Updating cart attributes with provided name: ${providerNameToSet}`);
        }


        // Now, update the cart attributes using finalProviderName (which could be '', a name, or null if error)
        // Ensure we only update if we have an affiliate code active
        if (affiliateCode) {
            const cartData = JSON.parse(localStorage.getItem('cartbot_data_cart')) || { attributes: {} };
            const attributes = cartData.attributes || {};

            // Set or remove the attribute based on the final name
            if (finalProviderName !== null && finalProviderName !== 'Select your Provider') {
                 attributes.providerId = finalProviderName; // Store name (or empty string for None)
                 console.log(`Setting cart attribute providerId to: "${finalProviderName}"`);
            } else {
                 // Maybe remove if null or placeholder? Optional. Let's set to empty for now.
                 attributes.providerId = '';
                 console.log('Setting cart attribute providerId to empty string (initial/error/placeholder).');
                 // delete attributes.providerId; // Alternative: remove attribute entirely
                 // console.log('Removing cart attribute providerId.');
            }

            cartData.attributes = attributes;
            localStorage.setItem('cartbot_data_cart', JSON.stringify(cartData));
            console.log("Cart attributes after update:", cartData);
        } else {
             console.log("Skipping cart attribute update as no affiliate code is active.");
        }

    } catch (error) {
        console.error("Error accessing localStorage or updating cart attributes:", error);
    }
}
